export class GameUtils {
  static zeroPad(num, places) {
    return String(num).padStart(places, '0');
  }
}
